import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { apiQueryDefaultImageListInfo } from '../../api/combineApi';
import { REQUEST_SUCCESS_CODE } from '../../constants';
export var DefaultImagesImageTypeEnum;

(function (DefaultImagesImageTypeEnum) {
  DefaultImagesImageTypeEnum["brokerProductBannerBusinessInsurance"] = "broker_production_banner_business";
  DefaultImagesImageTypeEnum["brokerProductBannerGoodsInTransite"] = "broker_production_banner_git";
})(DefaultImagesImageTypeEnum || (DefaultImagesImageTypeEnum = {}));

export var createDefaultImagesStore = create()(immer(function (set, get) {
  return {
    state: {
      defaultImagesListMap: {}
    },
    actions: {
      updateDefaultImagesList: function () {
        var _updateDefaultImagesList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
          var _data$imageType;

          var promises, resList;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (data !== null && data !== void 0 && (_data$imageType = data.imageType) !== null && _data$imageType !== void 0 && _data$imageType.length) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  promises = [];
                  data.imageType.forEach(function (key) {
                    promises.push(apiQueryDefaultImageListInfo({
                      business_type: key
                    }));
                  });
                  _context.next = 6;
                  return Promise.all(promises);

                case 6:
                  resList = _context.sent;
                  resList.forEach(function (res, index) {
                    var _res$;

                    if ((res === null || res === void 0 ? void 0 : (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.code) === REQUEST_SUCCESS_CODE) {
                      var listMap = get().state.defaultImagesListMap;
                      set(function (store) {
                        var _res$2;

                        store.state.defaultImagesListMap = _objectSpread(_objectSpread({}, listMap), {}, _defineProperty({}, data.imageType[index], ((res === null || res === void 0 ? void 0 : (_res$2 = res[0]) === null || _res$2 === void 0 ? void 0 : _res$2.data) || []).map(function (item) {
                          return _objectSpread(_objectSpread({}, item), {}, {
                            value: item.url,
                            label: index,
                            id: item.imageId
                          });
                        })));
                      });
                    }
                  });

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function updateDefaultImagesList(_x) {
          return _updateDefaultImagesList.apply(this, arguments);
        }

        return updateDefaultImagesList;
      }()
    }
  };
}));